var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "loginForm",
          staticClass: "ec-login-form switch-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            hideRequiredMark: "",
            colon: false,
            labelAlign: "left",
          },
        },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "userName",
                label: _vm.$t("common_form_login_name_or_phone"),
                htmlFor: "userName",
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "userName",
                    expression: "'userName'",
                  },
                ],
                attrs: { type: "text" },
                model: {
                  value: _vm.form.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userName", $$v)
                  },
                  expression: "form.userName",
                },
              }),
            ],
            1
          ),
          _vm.captcha
            ? _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "imgCode",
                    label: _vm.$t("common_form_identifying_code"),
                    htmlFor: "imgCode",
                  },
                },
                [
                  _c(
                    "a-input",
                    {
                      directives: [
                        {
                          name: "forlogin",
                          rawName: "v-forlogin",
                          value: "imgCode",
                          expression: "'imgCode'",
                        },
                      ],
                      attrs: { autoComplete: "off", maxLength: 4 },
                      model: {
                        value: _vm.form.imgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "imgCode", $$v)
                        },
                        expression: "form.imgCode",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "56px",
                            height: "33px",
                            background: "rgb(253, 253, 253)",
                          },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [
                          _vm.imgCodeLoading
                            ? _c("a-spin", {
                                staticStyle: {
                                  "margin-left": "25px",
                                  "margin-top": "9px",
                                },
                                attrs: { size: "small" },
                              })
                            : _c("img", {
                                staticStyle: {
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "100%",
                                },
                                attrs: { src: _vm.imgCodeData },
                                on: { click: _vm.getImgCode },
                              }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "password",
                label: _vm.$t("common_form_login_pd"),
                htmlFor: "password",
              },
            },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "password",
                    expression: "'password'",
                  },
                ],
                attrs: { type: "password" },
                on: {
                  keyup: function ($event) {
                    if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                      return null
                    return _vm.onSubmit.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm.ERP1
            ? _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "subjectCode",
                    label: _vm.$t("common_form_customer_code"),
                    htmlFor: "subjectCode",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "forlogin",
                        rawName: "v-forlogin",
                        value: "subjectCode",
                        expression: "'subjectCode'",
                      },
                    ],
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          $event.keyCode !== 13
                        )
                          return null
                        return _vm.onSubmit.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.form.subjectCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "subjectCode", $$v)
                      },
                      expression: "form.subjectCode",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.ERP1
        ? _c(
            "div",
            { staticClass: "ec-login-remend" },
            [
              _c(
                "a-checkbox",
                {
                  staticClass: "login-form__checkbox",
                  model: {
                    value: _vm.form.hasExpireTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "hasExpireTime", $$v)
                    },
                    expression: "form.hasExpireTime",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_five_auto_login5天")))]
              ),
              _c(
                "div",
                {
                  staticClass: "link",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("to", "backEmail")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_forget_password")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "a",
        {
          staticClass: "ec-login-submit",
          class: { "ec-login-submit__loading": _vm.submitLoading },
          on: {
            click: _vm.onSubmit,
            keyup: function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                return null
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm.submitLoading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px", color: "#fff" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _c("span", [_vm._v(_vm._s(_vm.$t("common_login_title")))]),
        ],
        1
      ),
      !_vm.ERP1
        ? _c(
            "div",
            { staticClass: "ec-login-agreement" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("common_login_登录即表明您同意"))),
              ]),
              _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("agreement", "agreementVisible")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_ServiceAgreement")))]
              ),
              _c("span", [_vm._v(_vm._s(_vm.$t("common_conj_and")))]),
              _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("agreement", "policyVisible")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_PrivacyPolicy")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "margin-top": "10px",
          },
        },
        [
          !_vm.ERP1
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      margin: "1px",
                      height: "30px",
                      "font-size": "14px",
                      "font-weight": "400",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common_login_login_tip")))]
                ),
                _c(
                  "a-button",
                  {
                    staticStyle: { padding: "0 4px" },
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("to", "register")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common_login_免费注册")) + " ")]
                ),
              ]
            : [
                _c(
                  "a-button",
                  {
                    staticStyle: { margin: "0 auto" },
                    attrs: { type: "link" },
                    on: {
                      click: function ($event) {
                        _vm.ERP1 = false
                      },
                    },
                  },
                  [
                    _c("div", [_vm._v("11111")]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("common_login_return_login")) + " "
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }